import { Text } from '@ltvco/refresh-lib/theme';

type PropertySizeDisplayProps = {
  details?: {
    square_footage?: number;
    beds?: number;
    baths?: number;
  };
};

export const PropertySizeDisplay: React.FC<PropertySizeDisplayProps> = ({
  details,
}) => {
  if (!details) {
    return null;
  }

  const displayParts: string[] = [];

  // Add square footage if truthy
  if (details.square_footage) {
    displayParts.push(`${details.square_footage} sq ft`);
  }

  // Add beds and baths together only if both are truthy
  if (details.beds && details.baths) {
    displayParts.push(
      `${details.beds} bed${details.beds > 1 ? 's' : ''} and ${
        details.baths
      } bath${details.baths > 1 ? 's' : ''}`
    );
  }

  // Return null if no truthy values
  if (displayParts.length === 0) {
    return null;
  }

  return <Text>{displayParts.join(' | ')}</Text>;
};
